(function () {
  function initTrackOrderForm(container) {
    if (container.dataset.trackOrderInit === 'true') return;
    container.dataset.trackOrderInit = 'true';

    const domain = container.dataset.trackDomain;
    const tabs = container.querySelectorAll('[data-track-tab]');
    const panels = container.querySelectorAll('[data-track-panel]');

    function activateTab(tabName) {
      tabs.forEach(function (tab) {
        const isActive = tab.dataset.trackTab === tabName;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.tabIndex = isActive ? 0 : -1;
      });

      panels.forEach(function (panel) {
        const isActive = panel.dataset.trackPanel === tabName;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activateTab(tab.dataset.trackTab);
      });

      tab.addEventListener('keydown', function (event) {
        const tabList = Array.from(tabs);
        const currentIndex = tabList.indexOf(tab);
        let nextIndex = currentIndex;

        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          nextIndex =
            event.key === 'ArrowRight'
              ? (currentIndex + 1) % tabList.length
              : (currentIndex - 1 + tabList.length) % tabList.length;
          tabList[nextIndex].focus();
          activateTab(tabList[nextIndex].dataset.trackTab);
        } else if (event.key === 'Home') {
          event.preventDefault();
          tabList[0].focus();
          activateTab(tabList[0].dataset.trackTab);
        } else if (event.key === 'End') {
          event.preventDefault();
          tabList[tabList.length - 1].focus();
          activateTab(tabList[tabList.length - 1].dataset.trackTab);
        }
      });
    });

    container.querySelectorAll('.track-order-form__form').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();

        const panel = form.closest('[data-track-panel]');
        const panelType = panel ? panel.dataset.trackPanel : 'order';

        if (panelType === 'order') {
          const orderNumber = form.querySelector('[name="order-number"]').value.trim();
          const email = form.querySelector('[name="email"]').value.trim();

          if (!orderNumber || !email) {
            form.reportValidity();
            return;
          }

          const params = new URLSearchParams({
            'order-number': orderNumber,
            email: email
          });
          window.location.href = 'https://' + domain + '/order-status?' + params.toString();
          return;
        }

        const trackingNumber = form.querySelector('[name="tracking-number"]').value.trim();

        if (!trackingNumber) {
          form.reportValidity();
          return;
        }

        window.location.href =
          'https://' + domain + '/' + encodeURIComponent(trackingNumber);
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.track-order-form').forEach(initTrackOrderForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
